export default "__VITE_ASSET__4c84358f__"